module.exports = __webpack_public_path__ + "img/aqtobe2.67065d53.jpg";